export default __webpack_public_path__ + "static/media/Digital Keys.18fc85a8.svg";